import React from "react";
import { makeStyles } from "tss-react/mui";
import { SubscriptionRunStatuses } from "constants/reportSubscriptions";
import SubscriptionHeader from "./SubscriptionHeader";
import SubscriptionFiltersDisplay from "./SubscriptionFiltersDisplay";
import SubscriptionScheduleDisplay from "./SubscriptionScheduleDisplay";
import SubscriptionLastRunStatus from "./SubscriptionLastRunStatus";
import SubscriptionActions from "./SubscriptionActions";

const useStyles = makeStyles()(() => ({
	card: {
		border: "1px solid #d1d5db",
		borderRadius: "6px",
		padding: "10px 14px",
		backgroundColor: "#fff",
		display: "flex",
		flexDirection: "column",
		gap: "2px",
	},
	failed: {
		borderColor: "#fca5a5",
		backgroundColor: "#fef2f2",
	},
	paused: {
		opacity: 0.75,
	},
}));

const ReportSubscriptionItem = ({ subscription, onToggle, onEdit, onDelete }) => {
	const { classes, cx } = useStyles();
	const isFailed = subscription.lastRunStatus === SubscriptionRunStatuses.Failed;
	return (
		<div
			className={cx(
				classes.card,
				isFailed && classes.failed,
				!subscription.isActive && classes.paused
			)}
		>
			<SubscriptionHeader
				subscription={subscription}
				onToggle={() => onToggle(subscription.id)}
			/>
			<SubscriptionFiltersDisplay filters={subscription.filters} />
			<SubscriptionScheduleDisplay subscription={subscription} />
			<SubscriptionLastRunStatus subscription={subscription} />
			<SubscriptionActions
				onEdit={() => onEdit(subscription)}
				onDelete={() => onDelete(subscription.id)}
			/>
		</div>
	);
};

export default ReportSubscriptionItem;
